import React from "react";
import { Link } from "react-router-dom";

const RecentFiles = ({ recentfolders }) => {
    return (
        <div className="col-xl-6">
            <div className="global_cardbox">
                <div className="global_card_header">
                    <div className="global_head_tag">
                        <span>
                            <i className="fa-solid fa-file"></i>
                        </span>
                        Recent Files
                    </div>
                </div>
                <div className="card_body">
                    <p>These are the items you recently accessed. This private list is only visible to you.</p>
                    <div className="recent_file_area">
                        <ul className="recent_file_item_list">
                            {/* ✅ Generate `cnt` number of list items dynamically */}
                            {recentfolders.length > 0 ? (
                                recentfolders.map((folder) => (
                                    <li key={folder.entity_id}>
                                        <Link to={`/folder-details/${folder.entity_id}`}>
                                            <span className="recent_file_item_icon">
                                                <i className="fas fa-folder-open"></i>
                                            </span>
                                            <span className="recent_file_item_filename">
                                                <h6>{folder.entity_name}</h6>
                                                <em>Shared Folders</em>
                                            </span>
                                        </Link>
                                    </li>
                                ))
                            ) : (
                                <ul className="recent_file_item_list">
                                    <li>
                                        No Folders Found
                                    </li>
                                </ul>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecentFiles;
